var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0127 18.9695C35.0127 18.9695 28.2097 13.0495 25.2935 23.1973C33.0693 28.2715 35.0127 18.9695 35.0127 18.9695Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0694 32.0125L33.2046 28.6941",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0186 35.3309L30.1538 32.0125",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34421 28.1016C3.52483 26.3368 3.07422 24.4086 3.07422 22.389L5.74388 1.48285L13.7968 8.32068C15.8929 7.55068 18.1983 7.12419 20.6177 7.12419H21.3805C23.7999 7.12419 26.1052 7.55068 28.2014 8.32068L36.2543 1.48285L38.9239 22.389C38.9239 24.4086 38.4733 26.3368 37.6539 28.1016",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4023 36.8188C16.3348 37.456 18.43 37.8048 20.619 37.8048H21.3817C24.7896 37.8048 27.9717 36.9597 30.663 35.4962",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98828 18.9695C6.98828 18.9695 13.7913 13.0495 16.7075 23.1973C8.93171 28.2715 6.98828 18.9695 6.98828 18.9695Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93115 32.0124L8.32623 28.9211",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33828 34.6719L4.98145 35.3292",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8463 22.0571C12.6888 22.0571 13.3718 21.4628 13.3718 20.7297C13.3718 19.9967 12.6888 19.4024 11.8463 19.4024C11.0038 19.4024 10.3208 19.9967 10.3208 20.7297C10.3208 21.4628 11.0038 22.0571 11.8463 22.0571Z",
    fill: "#5671A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.152 22.0571C30.9945 22.0571 31.6775 21.4628 31.6775 20.7297C31.6775 19.9967 30.9945 19.4024 30.152 19.4024C29.3095 19.4024 28.6265 19.9967 28.6265 20.7297C28.6265 21.4628 29.3095 22.0571 30.152 22.0571Z",
    fill: "#5671A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.806 35.5539C12.0412 36.2194 11.0236 36.586 9.94066 36.586C8.85777 36.586 7.84014 36.2194 7.0743 35.553C6.30949 34.8876 5.88814 34.0022 5.88916 33.0608C5.88916 29.9591 9.25799 26.9929 9.40131 26.8682C9.69944 26.6089 10.1819 26.6089 10.48 26.8682C10.6233 26.9929 13.9922 29.959 13.9921 33.0608C13.9932 34.0021 13.5718 34.8876 12.806 35.5539V35.5539ZM9.94066 28.3293C9.06107 29.2358 7.41461 31.1836 7.41461 33.0608C7.41358 33.6483 7.67688 34.2001 8.15302 34.6144C8.63026 35.0297 9.26437 35.2588 9.94074 35.2589C11.2912 35.2588 12.4679 34.235 12.4669 33.0608C12.4668 31.1836 10.8203 29.2359 9.94066 28.3293V28.3293Z",
    fill: "#5671A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.051 30.836L21 27.5175",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9487 30.836L20.9998 27.5175",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9487 27.5175H24.0508",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat1);
export default __webpack_public_path__ + "static/media/cat1.7ca8d824d2fb2b0fa3284d3cdc57ab60.svg";
export { ForwardRef as ReactComponent };